import React, { Component } from 'react'
import { Container, Row, Col } from 'components/Layout'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import s from './FlowCreateModal.scss'
import sMarg from 'styles/modules/margins.scss'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import AnimationFade from 'components/Animation/AnimationFade'
import i from 'icepick'

export const TemplateCard = ({ name, description, onClick }) => (
  <Col className={cn(sLay['flex-50'], sLay['flex-xs-100'], sMarg.mb15, 'sm')}>
    <div className={s.templateCard} onClick={onClick}>
      <div className={sText.descrip2} style={{ marginBottom: '5px' }}>
        {name}
      </div>
      <div>{description}</div>
    </div>
  </Col>
)

const FlowCreateModal = props => {
  const { templates, service, showType, createFlow, push, createLoading } = props

  const createAndNav = ({ nodes = [], links, name, type }) => {
    // Set the service info in the first incoming_call node
    const incomingCallOrSmsNodeIndex = nodes.findIndex(
      node => node.type === 'incoming_call' || node.type === 'incoming_sms'
    )
    const nodesUpdated =
      service && incomingCallOrSmsNodeIndex >= 0
        ? i.assocIn(nodes, [incomingCallOrSmsNodeIndex, 'extras'], {
            number: service.number,
            numberSid: service.id,
          })
        : nodes
    return createFlow({ nodes: nodesUpdated, links, name, type }).then(({ value: { data } }) =>
      push(`/dashboard/flows/${data.id}`)
    )
  }

  return (
    <Container
      style={{ background: 'rgba(0, 0, 0, 0.03)', padding: '30px 30px 20px' }}
      className="sm"
    >
      <AnimationFade in={createLoading}>
        <LoadingOverlay />
      </AnimationFade>
      <div className={cn(sText.descrip1, sMarg.mb30, sText.center)}>
        Choose a template to get started:
      </div>
      {(!showType || showType === 'call') && (
        <div>
          <div className={cn(sText.descrip3, sMarg.mb30, sText.center)}>Call Flows:</div>
          <Row
            className={cn(
              sLay['layout-gt-xs-row'],
              sLay['layout-xs-column'],
              sLay['layout-wrap'],
              'sm'
            )}
          >
            <TemplateCard
              name="Start from scratch"
              description="Create a new call flow from scratch."
              onClick={() =>
                createAndNav({
                  nodes: [],
                  links: [],
                  type: 'incoming_call',
                })
              }
            />
            {templates
              .filter(item => item.type === 'incoming_call')
              .map(template => (
                <TemplateCard
                  key={template.name}
                  name={template.name}
                  description={template.description}
                  onClick={() =>
                    createAndNav({
                      nodes: template.nodes,
                      links: template.links,
                      name: template.name,
                      type: template.type,
                    })
                  }
                />
              ))}
          </Row>
        </div>
      )}
      {/* {(!showType || showType === 'phone-system') && (
        <div>
          <div className={cn(sText.descrip3, sMarg.mv30, sText.center)}>Phone System Flows:</div>
          <Row
            className={cn(
              sLay['layout-gt-xs-row'],
              sLay['layout-xs-column'],
              sLay['layout-wrap'],
              'sm'
            )}
          >
            <TemplateCard
              name="Start from scratch"
              description="Create a new sms flow from scratch."
              onClick={() =>
                createAndNav({
                  nodes: [],
                  links: [],
                  type: 'phone_system_incoming_call',
                })
              }
            />
            {templates
              .filter(item => item.type === 'phone_system_incoming_call')
              .map(template => (
                <TemplateCard
                  key={template.name}
                  name={template.name}
                  description={template.description}
                  onClick={() =>
                    createAndNav({
                      nodes: template.nodes,
                      links: template.links,
                      name: template.name,
                      type: template.type,
                    })
                  }
                />
              ))}
          </Row>
        </div>
      )} */}
      {(!showType || showType === 'sms') && (
        <div>
          <div className={cn(sText.descrip3, sMarg.mv30, sText.center)}>SMS Flows:</div>
          <Row
            className={cn(
              sLay['layout-gt-xs-row'],
              sLay['layout-xs-column'],
              sLay['layout-wrap'],
              'sm'
            )}
          >
            <TemplateCard
              name="Start from scratch"
              description="Create a new sms flow from scratch."
              onClick={() =>
                createAndNav({
                  nodes: [],
                  links: [],
                  type: 'incoming_sms',
                })
              }
            />
            {templates
              .filter(item => item.type === 'incoming_sms')
              .map(template => (
                <TemplateCard
                  key={template.name}
                  name={template.name}
                  description={template.description}
                  onClick={() =>
                    createAndNav({
                      nodes: template.nodes,
                      links: template.links,
                      name: template.name,
                      type: template.type,
                    })
                  }
                />
              ))}
          </Row>
        </div>
      )}
    </Container>
  )
}

export default FlowCreateModal



// WEBPACK FOOTER //
// ./src/features/Flows/FlowCreateModal/FlowCreateModal.jsx